module.exports = __webpack_public_path__ + "img/Weapon_138.eb4d979a.png";